import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { ReactNode } from 'react';
import styled from 'styled-components';

import { IconButton } from 'atoms/buttons/IconButton';
import { Horizontal } from 'atoms/layout/flex';
import { regularMaterial } from 'style/utils';

const Wrapper = styled(Horizontal)`
  min-width: min(100%, 500px);
  padding: var(--intermediate-unit) var(--double-unit);
  border: 1px solid var(--c-nd-150);
  border-radius: var(--double-unit);
  align-items: center;
  justify-content: space-between;

  ${regularMaterial}
`;

type Props = {
  onCancel: () => void;
  children: ReactNode;
  button: ReactNode;
};

export const SelectionSummary = ({ button, children, onCancel }: Props) => {
  return (
    <Wrapper>
      {children}
      <Horizontal>
        {button}
        <IconButton onClick={onCancel} icon={faTimes} color="red" />
      </Horizontal>
    </Wrapper>
  );
};
